<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="save"
                            :loading="dataset.loading" v-if="page.isNew">Salvar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataset.loading" v-if="!page.isNew">Atualizar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/manutencoes/estoque">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-card class="card-form-outlined">
                        <v-card-title class="card-group-title">Identificação</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field dense outlined label="Nome da peça"
                                        v-model="dataset.data.name" :rules="[$rules.required]"
                                        hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field dense outlined label="SKU / Código"
                                        v-model="dataset.data.sku" hide-details="auto"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field dense outlined label="Unidade de medida"
                                        v-model="dataset.data.unit" hint="Ex: unidade, litro, metro"
                                        persistent-hint hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field dense outlined label="Localização"
                                        v-model="dataset.data.location" hint="Ex: Prateleira A3"
                                        persistent-hint hide-details="auto"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    <v-card class="card-form-outlined">
                        <v-card-title class="card-group-title">Estoque e custo</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="4">
                                    <v-text-field dense outlined type="number" label="Quantidade mínima"
                                        v-model="dataset.data.minimum_quantity" min="0"
                                        hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field dense outlined type="number" label="Quantidade atual"
                                        v-model="dataset.data.current_quantity" min="0"
                                        hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field dense outlined type="number" label="Custo médio" prefix="R$"
                                        v-model="dataset.data.average_cost" min="0" step="0.01"
                                        hide-details="auto"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-textarea dense outlined label="Observações"
                                        v-model="dataset.data.notes" rows="2" auto-grow
                                        hide-details="auto"></v-textarea>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
import axios from 'axios'

export default {
    name: 'PartStockDetails',

    data: () => ({
        page: {
            title: '',
            isNew: true,
        },
        dataset: {
            data: {
                name: '',
                sku: '',
                unit: 'unidade',
                location: '',
                minimum_quantity: 0,
                current_quantity: 0,
                average_cost: 0,
                notes: '',
            },
            breadcrumbItems: [],
            loading: false,
        },
        dataForm: {
            validForm: true,
        },
    }),

    created() {
        this.loadData()
    },

    methods: {
        async loadData() {
            this.setPage()
            this.listBreadCrumbItems()

            if (!this.page.isNew) {
                await this.load()
            }
        },

        goBack() {
            this.$router.replace('/manutencoes/estoque')
        },

        setPage() {
            this.page.isNew = this.$route.params.id === 'novo'
            this.page.title = this.page.isNew ? 'Nova peça' : 'Editar peça'
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                { text: 'Homepage', disabled: false, to: '/home', exact: true },
                { text: 'Manutenções', disabled: false, to: '/manutencoes', exact: true },
                { text: 'Estoque', disabled: false, to: '/manutencoes/estoque', exact: true },
                { text: this.page.isNew ? 'Nova peça' : 'Editar peça', disabled: true, exact: true },
            ]
        },

        async load() {
            this.dataset.loading = true
            try {
                const { data } = await axios.get(`/api/v2/maintenance/part-stocks/${this.$route.params.id}`)
                const item = data?.content || {}

                this.dataset.data = {
                    name: item.name || '',
                    sku: item.sku || '',
                    unit: item.unit || 'unidade',
                    location: item.location || '',
                    minimum_quantity: item.minimum_quantity || 0,
                    current_quantity: item.current_quantity || 0,
                    average_cost: item.average_cost || 0,
                    notes: item.notes || '',
                }
            } catch (error) {
                this.$dialog.notify.error('Erro ao carregar a peça.', { position: 'top-right', timeout: 5000 })
            } finally {
                this.dataset.loading = false
            }
        },

        buildPayload() {
            return {
                name: this.dataset.data.name,
                sku: this.dataset.data.sku || null,
                unit: this.dataset.data.unit || 'unidade',
                location: this.dataset.data.location || null,
                minimum_quantity: Number(this.dataset.data.minimum_quantity || 0),
                current_quantity: Number(this.dataset.data.current_quantity || 0),
                average_cost: Number(this.dataset.data.average_cost || 0),
                notes: this.dataset.data.notes || null,
            }
        },

        async save() {
            if (!this.$refs.form.validate()) return

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja salvar a peça?',
                title: 'Salvar peça',
                actions: { false: 'Cancelar', true: 'Salvar' },
            })

            if (!proceedAction) return

            this.dataset.loading = true

            try {
                await axios.post('/api/v2/maintenance/part-stocks', this.buildPayload())

                this.$dialog.notify.info('Peça criada com sucesso.', { position: 'top-right', timeout: 2000 })

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes ? this.$codes(error) : 'Erro ao salvar peça.', {
                    position: 'top-right', timeout: 5000,
                })
            } finally {
                this.dataset.loading = false
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar a peça?',
                title: 'Atualizar peça',
                actions: { false: 'Cancelar', true: 'Atualizar' },
            })

            if (!proceedAction) return

            this.dataset.loading = true

            try {
                await axios.patch(`/api/v2/maintenance/part-stocks/${this.$route.params.id}`, this.buildPayload())

                this.$dialog.notify.info('Peça atualizada com sucesso.', { position: 'top-right', timeout: 2000 })

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes ? this.$codes(error) : 'Erro ao atualizar peça.', {
                    position: 'top-right', timeout: 5000,
                })
            } finally {
                this.dataset.loading = false
            }
        },
    },
}
</script>
